module.exports = __webpack_public_path__ + "static/media/empty-shoppingcart.ca28ffdd.png";